import { apiUrl_ } from '../config'
import myAxios from '../myAxios'
import axios, { CancelTokenSource } from 'axios'
import { IPaymentsPlan } from '../../interfaces/IPaymentsPlan'
import {
  IStudentDetails,
  ITeacherDetails,
  IUserType,
} from '../../interfaces/user.interface'
import { envConfig } from '../envConfig'
import {
  ILiveClassPlatform,
  IRepeatClassSchedule,
} from '../../components/Schedules/ILiveClassSchedule'
import { ICourse } from '../../interfaces/ICourse'
import { ISchool } from 'interfaces/school.interface'

const forumUrl = apiUrl_ + '/forums/v1'
const userNotesUrl = apiUrl_ + '/user_notes/v1'

const myBaseUrlDomain = apiUrl_
const myBaseUrl = `${myBaseUrlDomain}/schools`
const studentApiUrl = `${myBaseUrlDomain}/courses/v1/stu`
const teacherApiUrl = `${myBaseUrlDomain}/courses/v1/tea`
const myBaseScheduleUrl = `${myBaseUrlDomain}/course-schedule/v1`
const CloudinaryBaseUrl = `${envConfig.NEXT_PUBLIC_CLOUDINARY_BASE_URL}/upload`

// const assessmentsApiUrl = myBaseUrlDomain + "/assessments/api/v1";

export const SearchForSchoolUrl = (hostname: string) => {
  // hostname="5e9016c5bb45616a6d1cf659.pledre.school"

  const domainArray = hostname.split('.')
  const schoolUrl = domainArray[0]
  // === "www" ? domainArray[1] : domainArray[0]
  const secondToLastDomainUrl = domainArray[domainArray.length - 2]

  if (hostname === 'class.pledre.com') {
    return myAxios.get(
      `${myBaseUrl}/auth/api/v1/custom-domain-details?domain_name=${hostname}`,
    )
  } else if (
    secondToLastDomainUrl === 'pledre' &&
    domainArray[0] !== 'www'
  ) {
    return myAxios.get(
      `${myBaseUrl}/auth/api/v1/school-details-from-url/${schoolUrl}`,
    )
  } else {
    if (domainArray[0] === 'www') {
      // remove www from url
      domainArray.shift()
      hostname = domainArray.join('.')
    }
    return myAxios.get(
      `${myBaseUrl}/auth/api/v1/custom-domain-details?domain_name=${hostname}`,
    )

    // const myBaseUrl = "http://localhost:3000/users/api/v1";
  }
}

export const GetSchoolDetailsFromId = (schoolId: String) => {
  return myAxios.get(
    `${myBaseUrl}/auth/api/v1/school-details-from-id/${schoolId}`,
  )
}

export const LoginStudentRequest = (opts: {
  userCode?: string
  schoolId: string
  password?: string
  idToken?: string
  ignorePasswordValidation?: boolean
  loginWith?: string
}) => {
  return myAxios.post(`${myBaseUrl}/auth/api/v1/students/login/`, {
    user_code: opts.userCode,
    school_id: opts.schoolId,
    password: opts.password,
    auth_token: opts.idToken,
    ignorePasswordValidation: opts.ignorePasswordValidation,
    login_with: opts.loginWith,
  })
}

export const LoginTeacherRequest = (opts: {
  userCode?: string
  schoolId: string
  password?: string
  idToken?: string
  ignorePasswordValidation?: boolean
  loginWith?: string
}) => {
  return myAxios.post(`${myBaseUrl}/auth/api/v1/teachers/login/`, {
    user_code: opts.userCode,
    school_id: opts.schoolId,
    password: opts.password,
    googleAuthToken: opts.idToken,
    ignorePasswordValidation: opts.ignorePasswordValidation,
    login_with: opts.loginWith,
  })
}

export const LoginAdminRequest = (opts: {
  userCode?: string
  schoolId: string
  password?: string
  idToken?: string
  ignorePasswordValidation?: boolean
  loginWith?: string
}) => {
  return myAxios.post(`${myBaseUrl}/auth/api/v1/admins/login/`, {
    user_code: opts.userCode,
    school_id: opts.schoolId,
    password: opts.password,
    googleAuthToken: opts.idToken,
    ignorePasswordValidation: opts.ignorePasswordValidation,
    login_with: opts.loginWith,
  })
}

export const checkIfUserEmailIsValidRequest = (opts: {
  userCode: string
  userType: IUserType | ''
  schoolId: string
}) => {
  return myAxios.post(
    `${myBaseUrl}/auth/api/v1/users/check-user-email/${opts.schoolId}`,
    {
      email: opts.userCode,
      userType: opts.userType,
    },
  )
}

export const RegisterStudentRequest = (opts: {
  name: String
  email: String
  schoolId: String
  schoolNo: String
  password?: String
  customAuthInput: any
  registerToken?: string
  registerWith?: string
  ignorePasswordValidation?: boolean
}) => {
  const {
    name,
    email,
    schoolId,
    schoolNo,
    password,
    customAuthInput,
    registerToken,
    registerWith,
    ignorePasswordValidation,
  } = opts
  return myAxios.post(`${myBaseUrl}/auth/api/v1/students/register/`, {
    name: name,
    email: email,
    school_id: schoolId,
    school_no: schoolNo,
    password: password,
    register_token: registerToken,
    register_with: registerWith,
    custom_auth_input: customAuthInput,
    ignore_password: ignorePasswordValidation,
  })
}

export const GetAllClassInSchool = (schoolId: string) => {
  return myAxios.get(`${myBaseUrl}/auth/api/v1/all-courses/${schoolId}`)
}

export const GetCategoriesInSchool = (schoolId: string) => {
  return myAxios.get(`${myBaseUrl}/auth/api/v1/school-categories/${schoolId}`)
}

export const GetAllPaymentsPlanInSchool = (schoolId: string) => {
  return myAxios.get(`${myBaseUrl}/auth/api/v1/all-payments-plan/${schoolId}`)
}

export const GetSchoolCategoryDetails = (categorySlug: string) => {
  return myAxios.get(
    `${myBaseUrl}/auth/api/v1/school-categories-details/${categorySlug}`,
  )
}

export const GetSchoolTimetable = (schoolId: string) => {
  return myAxios.get(`${myBaseUrl}/auth/api/v1/school-timetable/${schoolId}`)
}

export const GetAllTopicsInClass = (classId: string) => {
  return myAxios.get(`${myBaseUrl}/auth/api/v1/course_contents/${classId}`)
}

export const RegisterTeacherRequest = (opts: {
  name: String
  email: String
  schoolId: String
  schoolNo: String
  password: String
  customAuthInput: any
}) => {
  return myAxios.post(`${myBaseUrl}/auth/api/v1/teachers/register/`, {
    name: opts.name,
    email: opts.email,
    school_id: opts.schoolId,
    school_no: opts.schoolNo,
    password: opts.password,
    custom_auth_input: opts.customAuthInput,
  })
}

export const PostNewCourseRequest = (opts: {
  schoolId: String
  schoolNo: String
  teacherId: String
  courseName: String
  courseDesc: String
  price: number
  isPublic: Boolean
  courseTemplateId?: string
  shortCourseDescription?: string
  backgroundImg?: string
  isComingSoon?: boolean
  isHidden?: boolean
  endOfCourseContentId?: String
  endOfCourseContentMessage?: string
}) => {
  const body = {
    course_teacher_id: opts.teacherId,
    course_name: opts.courseName,
    course_description: opts.courseDesc,
    short_description: opts.shortCourseDescription,
    course_isPublic: opts.isPublic,
    price: opts.price,
    course_template_id: opts.courseTemplateId,
    background_image: opts.backgroundImg,
    is_coming_soon: opts.isComingSoon,
    is_hidden: opts.isHidden,
    end_of_course_content_id: opts.endOfCourseContentId,
    end_of_course_content_message: opts.endOfCourseContentMessage,
  }
  return myAxios.post(
    `${myBaseUrlDomain}/courses/v2/courses/?school_id=${opts.schoolId}&&school_no=${opts.schoolNo}`,
    body,
  )
}

export const UpdateCourseRequest = (
  courseId: String,
  schoolId: String,
  schoolNo: String,
  courseDetails: Omit<Partial<ICourse>, '_id'>,
) => {
  const body: { [k: string]: any } = {
    course_name: courseDetails.name,
    course_description: courseDetails.description,
    short_description: courseDetails.short_description,
    course_department: courseDetails.department,
    course_unit: courseDetails.unit,
    course_isPublic: courseDetails.isPublic,
    course_isHidden: courseDetails.isHidden,
    price: courseDetails.price,
    tutor_description: courseDetails.tutorDescription,
    tutor_img: courseDetails.tutorDescription,
    course_requirements: courseDetails.requirements,
    course_reviews: courseDetails.reviews,
    similar_courses: courseDetails.similarCourses,
    background_image: courseDetails.background_image,
    // course_duration: courseDetails.duration,
    course_start_date: courseDetails.start_date,
    course_end_date: courseDetails.end_date,
    layout_type: courseDetails.layout_type,
    compact_layout_content_background:
      courseDetails.compact_layout_content_background,
    approve_student_on_payment: courseDetails.approve_student_on_payment,
    disable_direct_registration: courseDetails.disable_direct_registration,
    unapprove_all_students_on_end_date:
      courseDetails.unapprove_all_students_on_end_date,
    student_access_limit_after_approval:
      courseDetails.student_access_limit_after_approval,
    is_coming_soon: courseDetails.isComingSoon,
    enable_affiliates: courseDetails.enable_affiliates,
    affiliates_percentage_off: courseDetails.affiliates_percentage_off,
    default_affiliate_commission: courseDetails.default_affiliate_commission,
    enable_tiering: courseDetails.enable_tiering,
    tiering_maximum: courseDetails.tiering_maximum,
    show_content_title_to_unapproved:
      courseDetails.show_content_title_to_unapproved,
    banner_image: courseDetails?.banner_image,
    course_calendly_link: courseDetails?.course_calendly_link,
    tiering_prices: courseDetails?.tiering_prices,
    mirror_course_id: courseDetails?.mirror_course_id,
    hide_related_courses: courseDetails?.hide_related_courses,
    end_of_course_content_id: courseDetails?.end_of_course_content_id,
    end_of_course_content_message: courseDetails?.end_of_course_content_message,
    find_school_preview_image: courseDetails?.find_school_preview_image,
  }

  // remove undefined from object
  Object.keys(body).forEach(key => body[key] === undefined && delete body[key])

  return myAxios.put(
    `${myBaseUrlDomain}/courses/v2/courses/${courseId}?school_id=${schoolId}&&school_no=${schoolNo}`,
    body,
  )
}

export const PostNewCertificateRequest = (opts: {
  courseId: string
  courseName: string
  school: ISchool
  signature: string
  certText: string
  index: number | null
}) => {
  const body = {
    school_id: opts.school?._id,
    course_id: opts.courseId,
    course_name: opts.courseName,
    signature: opts.signature,
    certification_text: opts.certText,
    cert_index: opts.index,
  }
  return myAxios.post(`${myBaseUrlDomain}/school-certificate/create`, body)
}

export const UpdateCertificateRequest = (props: {
  school?: ISchool
  certificateId?: string
  courseId?: string
  courseName?: string
  signature?: string
  certText?: string
  index?: number | null
}) => {
  const body = {
    course_id: props.courseId,
    course_name: props.courseName,
    signature: props.signature,
    certification_text: props.certText,
    cert_index: props.index,
  }
  return myAxios.put(
    `${myBaseUrlDomain}/school-certificate/certificate/${props.certificateId}?school_id=${props.school?._id}`,
    body,
  )
}

export const GetCertificatesRequest = (props: { school?: ISchool }) => {
  return myAxios.get(
    `${myBaseUrlDomain}/school-certificate/certificates?school_id=${props.school?._id}`,
  )
}

export const DeleteCertificateRequest = (props: {
  school: ISchool
  certificate_id: string
}) => {
  return myAxios.delete(
    `${myBaseUrlDomain}/school-certificate/certificate/${props.certificate_id}?school_id=${props.school._id}`,
  )
}

export const CreateNewStudentCertificate = (props: {
  courseName: string
  studentName: string
  studentId: string
  certificateId: string
  certificateImage: string
}) => {
  const body = {
    course_name: props.courseName,
    student_name: props.studentName,
    student_id: props.studentId,
    certificate_id: props.certificateId,
    certificate_image: props.certificateImage,
  }
  return myAxios.post(`${myBaseUrlDomain}/student-certificate/create`, body)
}

export const GetStudentCertificates = (props: { studentId: string }) => {
  return myAxios.get(
    `${myBaseUrlDomain}/student-certificate/certificates/${props.studentId}`,
  )
}

export const GetCertificateDetailsRequest = (props: {
  certificateId: string
}) => {
  return myAxios.get(
    `${myBaseUrlDomain}/student-certificate/certificates/id/${props.certificateId}`,
  )
}

export const UpdateStudentCertificate = (props: {
  studentId: string
  certificateId: string
  certificateImage: string
}) => {
  const body = {
    student_id: props.studentId,
    certificate_id: props.certificateId,
    certificate_image: props.certificateImage,
  }
  return myAxios.post(`${myBaseUrlDomain}/student-certificate/create`, body)
}

export const DeleteStudentCertificate = (props: {
  studentId: string
  studentCertificateId: string
}) => {
  return myAxios.delete(
    `${myBaseUrlDomain}/student-certificate/certificate/${props.studentCertificateId}?student_id=${props.studentId}`,
  )
}

export const NotifyStudentOnAssignCertificate = (props: {
  schoolId: string
  courseId: string
  studentId: string
}) => {
  const body = {
    course_id: props.courseId,
    student_id: props.studentId,
  }
  return myAxios.post(
    `${myBaseUrlDomain}/student-certificate/admin-assign-certificate?school_id=${props.schoolId}`,
    body,
  )
}

export const NotifyAdminOnStudentRequestForCertificate = (props: {
  schoolId: string
  courseId: string
  studentId: string
}) => {
  const body = {
    course_id: props.courseId,
    student_id: props.studentId,
  }
  return myAxios.post(
    `${myBaseUrlDomain}/student-certificate/request-for-certificate?school_id=${props.schoolId}`,
    body,
  )
}

export const GetAllSchoolRequest = () => {
  return myAxios.get(`${myBaseUrl}/auth/api/v1/all-schools/`)
}

export const GetAllPromotedSchoolRequest = () => {
  return myAxios.get(`${myBaseUrl}/auth/api/v1/promoted-schools/`)
}

export const searchForCourseInSchool = (
  school_id: string,
  searchQuery: string,
) => {
  // gets a single course detail
  return myAxios.get(
    `${myBaseUrl}/auth/api/v1/course_search/${school_id}/?&searchQuery=${searchQuery}`,
  )
}

export const searchForCourseInAllSchools = (searchQuery: string) => {
  // gets a single course detail
  return myAxios.get(
    `${myBaseUrl}/auth/api/v1/all_course_search/?&searchQuery=${searchQuery}`,
  )
}

export const AddSchoolLog = (
  school_id: string,
  user_id: string,
  user_type: string,
  course_id?: string,
) => {
  const body = {
    action: 'SCHOOL_VISIT',
    url: location.href,
    school_id: school_id,
    school_path: location.href,
    user_id: user_id,
    user_type: user_type,
    course_id: course_id,
  }

  return myAxios.post(`${myBaseUrlDomain}/analytics/v1`, body)
}

export const GetUserNotificationRequest = () => {
  return myAxios.get(`${myBaseUrl}/users/api/v1/notifications`)
}

export const AddExtensionsToUserRequest = (extension: any) => {
  const body = {
    extension_id: extension._id,
  }
  return myAxios.post(`${myBaseUrlDomain}/extensions/users/api/v1/add/`, body)
}

export const RemoveExtensionsToUserRequest = (extensionId: string) => {
  return myAxios.delete(
    `${myBaseUrlDomain}/extensions/users/api/v1/remove/extensions/${extensionId}`,
  )
}

export const SearchForExtensionRequest = (searchQuery: String) => {
  return myAxios.get(
    `${myBaseUrlDomain}/extensions/users/api/v1/search/?searchQuery=${searchQuery}`,
  )
}

export const PostUserCodeForResetPasswordRequest = (
  userCode: String,
  userType: String,
  schoolId: String,
  schoolUrl: String,
) => {
  return myAxios.post(`${myBaseUrl}/auth/api/v1/reset-password/`, {
    user_code: userCode,
    user_type: userType,
    school_id: schoolId,
    school_url: schoolUrl,
  })
}

export const CreateNewPasswordFromTokenRequest = (
  email: String,
  token: String,
  password: String,
  schoolUrl: String,
) => {
  return myAxios.post(`${myBaseUrl}/auth/api/v1/create-password/`, {
    email: email,
    token: token,
    password: password,
    school_url: schoolUrl,
  })
}

export const getUserNotes = () => {
  return myAxios.get(`${userNotesUrl}`)
}

export const searchUserNotes = (query: string) => {
  return myAxios.get(`${userNotesUrl}/search?searchQuery=${query}`)
}

export const addUserNotes = (note_title: string, note_content: string) => {
  const body = {
    note_title: note_title,
    note_content: note_content,
  }
  console.log(body)
  return myAxios.post(`${userNotesUrl}`, body)
}

export const deleteUserNotes = (note_id: string) => {
  return myAxios.delete(`${userNotesUrl}/${note_id}`)
}

export const updateUserNotes = (
  note_id: string,
  note_title: string,
  note_content: string,
) => {
  const body = {
    note_title: note_title,
    note_content: note_content,
  }
  console.log(body)
  return myAxios.put(`${userNotesUrl}/${note_id}`, body)
}

export const getCourseInCategoryRequest = (category_slug: string) => {
  return myAxios.get(
    `${myBaseUrl}/auth/api/v1/course-in-categories/${category_slug}`,
  )
}

export const getStudentCourses = () => {
  return myAxios.get(`${studentApiUrl}/courses`)
}

export const getTeacherCourseList = () => {
  return myAxios.get(`${teacherApiUrl}/courses`)
}

export const updateCourseByTeacher = (course_id: string, body: any) => {
  return myAxios.put(`${teacherApiUrl}/courses/${course_id}`, body)
}

export const getPosts = (page = 0) => {
  return myAxios.get(`${forumUrl}/posts/?page=${page}`)
}

export const getPostsByUser = () => {
  return myAxios.get(`${forumUrl}/posts`)
}

export const getPostDetails = (post_id: String) => {
  return myAxios.get(`${forumUrl}/posts/${post_id}`)
}

export const addPost = (post: String, media_url: string) => {
  const body = {
    post: post,
    media_url: media_url,
  }
  console.log(body)
  return myAxios.post(`${forumUrl}/posts`, body)
}

export const updatePost = (post_id: String, user_id: String, post: String) => {
  const body = {
    post_id: post_id,
    user_id: user_id,
    post: post,
  }
  console.log(body)
  return myAxios.put(`${forumUrl}/posts/${post_id}`, body)
}

export const deletePost = (post_id: String) => {
  return myAxios.delete(`${forumUrl}/posts/${post_id}`)
}

export const getReplyInPost = (post_id: String) => {
  return myAxios.get(`${forumUrl}/reply/posts/${post_id}`)
}

export const getReplyByUser = (user_id: String) => {
  user_id
  return myAxios.get(`${forumUrl}/reply`)
}

export const addReplyToPost = (post_id: String, reply: String) => {
  const body = {
    post_id: post_id,
    reply: reply,
  }
  console.log(body)
  return myAxios.post(`${forumUrl}/reply`, body)
}

export const updateReplyInPost = (
  reply_id: String,
  user_id: String,
  reply: String,
) => {
  const body = {
    reply_id: reply_id,
    user_id: user_id,
    reply: reply,
  }
  console.log(body)
  return myAxios.put(`${forumUrl}/reply/${reply_id}`, body)
}

export const deleteReplyFromPost = (reply_id: String, user_id: String) => {
  user_id
  return myAxios.delete(`${forumUrl}/reply/${reply_id}`)
}

export const getReplyDetails = (reply_id: String) => {
  return myAxios.get(`${forumUrl}/reply/${reply_id}`)
}

export const getUserBookmarks = () => {
  return myAxios.get(`${forumUrl}/bookmarks`)
}

export const addPostToBookmarks = (post_id: String) => {
  const body = {
    post_id: post_id,
  }
  console.log(body)
  return myAxios.post(`${forumUrl}/bookmarks`, body)
}

export const removeBookmarkFromPost = (post_id: String) => {
  return myAxios.delete(`${forumUrl}/bookmarks/posts/${post_id}`)
}

export const getUserUpvotes = (user_id: String) => {
  user_id
  return myAxios.get(`${forumUrl}/upvotes`)
}

export const addUpvotes = (
  user_id: String,
  voter_id: String,
  reply_id: String,
) => {
  // adds and removes upvote if already added
  const body = {
    user_id: user_id,
    reply_id: reply_id,
    voter_id: voter_id,
  }
  console.log(body)
  return myAxios.post(`${forumUrl}/upvotes`, body)
}

export const getUserDownvotes = (user_id: String) => {
  user_id
  return myAxios.get(`${forumUrl}/downvotes`)
}

export const addDownvotes = (
  user_id: String,
  voter_id: String,
  reply_id: String,
) => {
  const body = {
    user_id: user_id,
    reply_id: reply_id,
    voter_id: voter_id,
  }
  console.log(body)
  return myAxios.post(`${forumUrl}/downvotes`, body)
}

export const getReplyUpvotes = (reply_id: String) => {
  return myAxios.get(`${forumUrl}/upvotes/reply/${reply_id}`)
}

export const getReplyDownvotes = (reply_id: String) => {
  return myAxios.get(`${forumUrl}/downvotes/reply/${reply_id}`)
}

export const checkIfStudentIsTakingCourse = (courseId: string) => {
  // check if student is taking class
  return myAxios.get(`${studentApiUrl}/courses/check-student/${courseId}`)
}

export const addNewCourseForStudent = (
  courseId: string,
  courseCode: string,
) => {
  const body = { course_id: courseId, course_code: courseCode }
  return myAxios.put(`${studentApiUrl}/students/`, body)
}

export const deleteCourseFromStudent = (courseId: string) => {
  return myAxios.delete(`${studentApiUrl}/students/courses/${courseId}`)
}

export const uploadFileRequest = (
  data: any,
  file: any,
  progressPercent: Function,
  getCancelTokenSource?: (cancelTokenSource: CancelTokenSource) => void,
) => {
  const cancelTokenSource = axios.CancelToken.source()
  getCancelTokenSource?.(cancelTokenSource)

  // use regular axios for 3rd party client to prevent headers from leaking
  return axios.put(data.signedRequest, file, {
    cancelToken: cancelTokenSource.token,
    responseType: 'text',
    headers: {
      'Content-Type': file.type,
    },
    onUploadProgress: progressEvent => {
      let percentCompleted = Math.floor(
        (progressEvent.loaded * 100) / progressEvent.total,
      )
      progressPercent(percentCompleted)
    },
  })
}

export const uploadImageRequestCloudinary = (
  data: any,
  progressPercent: (percentCompleted: number) => void,
) => {
  // use regular axios for 3rd party client to prevent headers from leaking
  return axios.post(CloudinaryBaseUrl, data, {
    onUploadProgress: progressEvent => {
      let percentCompleted = Math.floor(
        (progressEvent.loaded * 100) / progressEvent.total,
      )
      progressPercent(percentCompleted)
    },
  })
}

export const createStripeCheckoutSession = (
  email: string,
  metadata: any,
  success_url: string,
  cancel_url: string,
  amount: number,
  currency: string,
  product_name: string,
) => {
  const body = {
    metadata: metadata,
    email: email,
    success_url: success_url,
    cancel_url: cancel_url,
    amount: amount,
    currency: currency,
    product_name: product_name,
  }
  return myAxios.post(
    `${myBaseUrlDomain}/users/api/v1/stripe/create-checkout-session`,
    body,
  )
}

export const updateBillingCard = (params: any) => {
  const body = { params }
  return myAxios.post(
    `${myBaseUrlDomain}/users/api/v1/stripe/update-billing-card`,
    body,
  )
}
export const createStripeSubscriptionSession = (
  priceId: string,
  email: string,
  successUrl: string,
  cancelUrl: string,
  quantity: number,
  schoolId: string,
  metadata: any,
) => {
  const body = {
    email: email,
    success_url: successUrl,
    cancel_url: cancelUrl,
    price_id: priceId,
    quantity: quantity,
    school_id: schoolId,
    metadata: metadata,
  }
  return myAxios.post(
    `${myBaseUrlDomain}/users/api/v1/stripe/create-subscription-session`,
    body,
  )
}

export const updateStripeSubscriptionQuantity = (
  subscriptionItemId: string,
  quantity: number,
) => {
  const body = {
    subscription_item_id: subscriptionItemId,
    quantity: quantity,
  }
  return myAxios.put(
    `${myBaseUrlDomain}/users/api/v1/stripe/subscription-quantity`,
    body,
  )
}

export const cancelStripeSubscription = (subscriptionId: string) => {
  const body = {
    subscription_id: subscriptionId,
  }
  return myAxios.put(
    `${myBaseUrlDomain}/users/api/v1/stripe/cancel-subscription`,
    body,
  )
}

export const createStripeBillingPortalSession = (returnUrl: string) => {
  const body = {
    return_url: returnUrl,
  }
  return myAxios.post(
    `${myBaseUrlDomain}/users/api/v1/stripe/create-billing-portal-session`,
    body,
  )
}

export const getSignedKeyForFileUpload = (opts: {
  filename: string
  file_unique_id: string
  filetype?: string
}) => {
  const { filetype, filename, file_unique_id } = opts
  return myAxios.get(
    `${myBaseUrlDomain}/gen/get_aws_key_upload?file_name=${filename}&file_type=
    ${filetype}&file_unique_id=${file_unique_id}`,
  )
}

export const GetUserJourneyProgress = (school_id?: string) => {
  return myAxios.get(
    `${myBaseUrlDomain}/user-journey/v2/result?&${
      school_id && 'school_id=' + school_id
    }`,
  )
}

export const GetCoursesInSchoolStudentIsNotTaking = (
  student_id: string,
  school_id: string,
) => {
  return myAxios.get(
    `${myBaseUrlDomain}/courses/v2/student-not-taking/${student_id}?&${
      school_id && 'school_id=' + school_id
    }`,
  )
}

export const UpdateStudentCourseApprovalEndDate = (
  studentId: string,
  courseId: string,
  schoolId: string,
  newDate: string | null,
) => {
  const body = {
    student_id: studentId,
    course_id: courseId,
    school_id: schoolId,
    student_approval_end_date: newDate,
  }
  return myAxios.put(
    `${myBaseUrlDomain}/courses/v2/students-course-approval?&${
      'school_id=' + schoolId
    }`,
    body,
  )
}

export const addStudentToCourseTier = (opts: {
  school_id: string
  course_id: string
  student_id: any
  tier: number
}) => {
  const body = { course_id: opts.course_id, tier: opts.tier }
  return myAxios.put(
    `${myBaseUrlDomain}/courses/v2/students-tier/${opts.student_id}?school_id=${opts.school_id}`,
    body,
  )
}

export const GetAuthenticatedUserCourseContent = (
  course_id: string,
  school_id: string,
) => {
  return myAxios.get(
    `${myBaseUrlDomain}/courses/v2/course-content-details/${course_id}?&${
      school_id && 'school_id=' + school_id
    }`,
  )
}

export const GetCourseDetails = (course_id?: string, school_id?: string) => {
  let url = `${myBaseUrlDomain}/courses/v2/course-details/${course_id}`
  if (school_id) {
    url = `${url}?&school_id=${school_id}`
  }

  return myAxios.get(url)
}

export const AddStudentToCourseRequestV2 = (
  student_id: string,
  course_id: string,
  school_id: string,
) => {
  const body = {
    school_id: school_id,
    course_id: course_id,
    student_id: student_id,
  }

  return myAxios.put(
    `${myBaseUrlDomain}/courses/v2/students/${student_id}?&${
      school_id && 'school_id=' + school_id
    }`,
    body,
  )
}

export const CreatePaymentsPlansRequest = (
  school_id: string,
  body: IPaymentsPlan,
) => {
  return myAxios.post(
    `${myBaseUrlDomain}/payments-plan/v2/plan/${school_id}/?school_id=${school_id}`,
    body,
  )
}

export const PutPaymentsPlansRequest = (
  school_id: string,
  payments_alert_id: string,
  paymentsBody: IPaymentsPlan,
) => {
  const body = { payments_alert_id: payments_alert_id, ...paymentsBody }
  return myAxios.put(
    `${myBaseUrlDomain}/payments-plan/v2/plan/${school_id}/?school_id=${school_id}`,
    body,
  )
}

export const DeletePaymentsPlansRequest = (
  school_id: string,
  payments_alert_id: string,
) => {
  return myAxios.delete(
    `${myBaseUrlDomain}/payments-plan/v2/plan/${school_id}/${payments_alert_id}/?school_id=${school_id}`,
  )
}

export const GetPaymentPlanDetails = (plan_id_or_slug: string) => {
  return myAxios.get(
    `${myBaseUrlDomain}/payments-plan/v2/plan-details/${plan_id_or_slug}`,
  )
}

export const GetPaymentsPlansRequest = (school_id: string) => {
  return myAxios.get(
    `${myBaseUrlDomain}/payments-plan/v2/plan/${school_id}/?school_id=${school_id}`,
  )
}

export const SendPaymentsPlansRequest = (
  school_id: string,
  payments_alert_id: string,
) => {
  const body = {
    payments_alert_id: payments_alert_id,
  }
  return myAxios.post(
    `${myBaseUrlDomain}/payments-plan/v2/send-payments-alerts/${school_id}/?school_id=${school_id}`,
    body,
  )
}

export const UpdateSchoolPlan = (
  school_id: string,
  plan: 'basic' | 'standard' | 'enterprise',
) => {
  const body = {
    plan: plan,
    school_id: school_id,
  }
  return myAxios.put(
    `${myBaseUrlDomain}/schools/v2/update-plan/?school_id=${school_id}`,
    body,
  )
}

export const GetSchoolActiveUserChat = (schoolId: string) => {
  return myAxios.get(
    `${myBaseUrlDomain}/schools/v2/active-user-chat/?school_id=${schoolId}`,
  )
}

export const GetSchoolAdmins = (schoolId: string) => {
  return myAxios.get(
    `${myBaseUrlDomain}/schools/v2/admins/?school_id=${schoolId}`,
  )
}

export const GetUnapprovedStudentsInSchool = (schoolId: string) => {
  return myAxios.get(
    `${myBaseUrlDomain}/schools/v2/unapproved-students/?school_id=${schoolId}`,
  )
}

export const GetUserCreditCardDetailsRequest = () => {
  return myAxios.get(`${myBaseUrlDomain}/credit-cards/v2/card`)
}

export const GetUserDetailsRequest = (
  userId: string,
  userType: IUserType,
  schoolId: string,
) => {
  return myAxios.get(
    `${myBaseUrlDomain}/school-users/v2/user-details/${userId}/?school_id=${schoolId}&user_type=${userType}`,
  )
}

export const GetMyDetailsRequest = () => {
  return myAxios.get(`${myBaseUrlDomain}/school-users/v2/me/`)
}

export const GetStudentPendingAndSubmittedAssessment = (
  userId: string,
  schoolId: string,
) => {
  return myAxios.get(
    `${myBaseUrlDomain}/assessments/v2/pending-and-submitted-student-assessments/${userId}/?school_id=${schoolId}`,
  )
}

export const GetAssessmentResultsInSchoolorCourse = (
  schoolId: string,
  scope?: 'school' | 'course',
  courseId?: string,
) => {
  if (scope && scope === 'course') {
    return myAxios.get(
      `${myBaseUrlDomain}/assessments/v2/school_assessment_results/?school_id=${schoolId}&scope=course&course_id=${courseId}`,
    )
  }
  return myAxios.get(
    `${myBaseUrlDomain}/assessments/v2/school_assessment_results/?school_id=${schoolId}`,
  )
}

export const updateAssessment = (
  _courseContentId: string,
  Quiz: any,
  schoolId: string,
) => {
  // Quiz["course_content_id"] = courseContentId;
  const body = {
    assessment: Quiz,
  }
  console.log('Update assessment body')
  return myAxios.put(
    `${myBaseUrlDomain}/assessments/v2/?school_id=${schoolId}`,
    body,
  )
}

export const getAssessmentsAvailableOnHomepage = (schoolId: string) => {
  return myAxios.get(
    `${myBaseUrlDomain}/assessments/v2/homepage_assessments?school_id=${schoolId}`,
  )
}

export const addNote = (body: {
  student_id: string
  school_id: string
  content: string
}) => {
  return myAxios.post(
    `${myBaseUrlDomain}/notes/v2/create?school_id=${body.school_id}`,
    body,
  )
}
export const updateNote = (body: {
  student_id: string
  note_id: string
  school_id: string
  content: string
}) => {
  return myAxios.put(
    `${myBaseUrlDomain}/notes/v2/update?school_id=${body.school_id}`,
    body,
  )
}

export const getAllNote = (student_id: string, school_id: string) => {
  return myAxios.get(
    `${myBaseUrlDomain}/notes/v2/student-notes/${student_id}?school_id=${school_id}`,
  )
}

export const deleteNote = (body: {
  student_id: string
  school_id: string
  note_id: string
}) => {
  return myAxios.put(
    `${myBaseUrlDomain}/notes/v2/delete?school_id=${body.school_id}`,
    body,
  )
}

export const UpdateUserDetailsRequest = (
  schoolId: string,
  userId: string,
  userType: 'teacher' | 'student',
  user_details: Partial<ITeacherDetails | IStudentDetails>,
) => {
  const body = {
    school_id: schoolId,
    user_details,
  }
  return myAxios.put(
    `${myBaseUrlDomain}/school-users/v2/update-user/${userId}/?school_id=${schoolId}&user_type=${userType}`,
    body,
  )
}

export const ChangeMySchoolUserPasswordRequest = (
  schoolId: string,
  oldPassword: string,
  newPassword: string,
) => {
  const body = {
    school_id: schoolId,
    old_password: oldPassword,
    new_password: newPassword,
  }
  return myAxios.post(
    `${myBaseUrlDomain}/school-users/v2/change-password?school_id=${schoolId}`,
    body,
  )
}

export const UpdateCourseAdsVideo = (
  courseId: String,
  schoolId: String,
  videoAdsUrl: string,
  videoName: string,
) => {
  const body = {
    course_id: courseId,
    school_id: schoolId,
    video_name: videoName,
    video_ads_url: videoAdsUrl,
  }
  return myAxios.put(
    `${myBaseUrlDomain}/courses/v2/update-course-ads-video/${courseId}?school_id=${schoolId}`,
    body,
  )
}

export const GetApprovedStudentsTakingCourse = (
  courseId: string,
  schoolId: string,
  withCourseProgress?: true,
) => {
  return myAxios.get(
    `${myBaseUrlDomain}/courses/v2/students/course_id/${courseId}/?&school_id=${schoolId}${
      withCourseProgress ? '&withCourseProgress=true' : ''
    }`,
  )
}

export const LockAllContentInModule = (
  courseId: string,
  courseLessonId: string,
  schoolId: string,
) => {
  const body = {
    course_id: courseId,
    course_lesson_id: courseLessonId,
  }
  return myAxios.put(
    `${myBaseUrlDomain}/courses/v2/lock-course-content-in-lesson/?&school_id=${schoolId}`,
    body,
  )
}

export const UnlockAllContentInModule = (
  courseId: string,
  courseLessonId: string,
  schoolId: string,
) => {
  const body = {
    course_id: courseId,
    course_lesson_id: courseLessonId,
  }
  return myAxios.put(
    `${myBaseUrlDomain}/courses/v2/unlock-course-content-in-lesson/?&school_id=${schoolId}`,
    body,
  )
}

export const GetSchoolDiscussionList = (
  schoolId: string,
  userId: string | undefined,
  filter: 'all' | 'course' | 'user',
  filterCourseId?: string,
  filterUserId?: string,
  startIndex?: number,
  numberToFetch?: number,
  searchQuery?: string,
) => {
  let urlPath = `school-discussion/v2/list/school/${schoolId}?&school_id=${schoolId}&filter=${filter}&course_id=${filterCourseId}&filter_user_id=${filterUserId}&start_index=${startIndex}&number_to_fetch=${numberToFetch}`
  if (userId) {
    urlPath = `${urlPath}&user_id=${userId}`
  }
  if (searchQuery) {
    urlPath = `${urlPath}&search_query=${searchQuery}`
  }
  return myAxios.get(`${myBaseUrlDomain}/${urlPath}`)
}

export const GetSingleSchoolDiscussionDetails = (
  schoolId: string,
  discussionId: string,
  userId: string | undefined,
) => {
  let urlPath = `school-discussion/v2/details/${discussionId}?&school_id=${schoolId}`
  if (userId) {
    urlPath = `${urlPath}&user_id=${userId}`
  }
  return myAxios.get(`${myBaseUrlDomain}/${urlPath}`)
}

export const PostSchoolDiscussion = (
  schoolId: string,
  courseId: string,
  discussionTitle: string,
  discussionContent: string,
) => {
  const body = {
    course_id: courseId,
    school_id: schoolId,
    discussion_title: discussionTitle,
    discussion_content: discussionContent,
  }

  return myAxios.post(
    `${myBaseUrlDomain}/school-discussion/v2/discussion/?&school_id=${schoolId}`,
    body,
  )
}

export const UpdateSchoolDiscussion = (
  schoolId: string,
  discussionId: string,
  discussionTitle: string,
  discussionContent: string,
) => {
  const body = {
    discussion_id: discussionId,
    discussion_title: discussionTitle,
    discussion_content: discussionContent,
  }

  return myAxios.put(
    `${myBaseUrlDomain}/school-discussion/v2/discussion/?&school_id=${schoolId}`,
    body,
  )
}

export const DeleteSchoolDiscussion = (
  schoolId: string,
  discussionId: string,
) => {
  return myAxios.delete(
    `${myBaseUrlDomain}/school-discussion/v2/discussion/${discussionId}/?&school_id=${schoolId}`,
  )
}

export const GetSchoolDiscussionCommentsList = (
  discussionId: string,
  schoolId: string,
) => {
  return myAxios.get(
    `${myBaseUrlDomain}/school-discussion/v2/comments/${discussionId}/?&school_id=${schoolId}`,
  )
}

export const PostSchoolDiscussionComment = (
  schoolId: string,
  discussionId: string,
  comment: string,
  commentMediaUrl: string[],
) => {
  const body = {
    comment: comment,
    school_id: schoolId,
    discussion_id: discussionId,
    comment_media_url: commentMediaUrl,
  }

  return myAxios.post(
    `${myBaseUrlDomain}/school-discussion/v2/comments/?&school_id=${schoolId}`,
    body,
  )
}

export const UpdateSchoolDiscussionComment = (
  schoolId: string,
  commentId: string,
  comment: string,
) => {
  const body = {
    comment_id: commentId,
    comment: comment,
  }

  return myAxios.put(
    `${myBaseUrlDomain}/school-discussion/v2/comments/?&school_id=${schoolId}`,
    body,
  )
}

export const DeleteSchoolDiscussionComment = (
  schoolId: string,
  commentId: string,
) => {
  return myAxios.delete(
    `${myBaseUrlDomain}/school-discussion/v2/comment/${commentId}/?&school_id=${schoolId}`,
  )
}

export const UpvoteDiscussion = (schoolId: string, discussionId: string) => {
  const body = { discussion_id: discussionId }
  return myAxios.put(
    `${myBaseUrlDomain}/school-discussion/v2/upvotes/?&school_id=${schoolId}`,
    body,
  )
}

export const DeleteDiscussionUpvote = (
  schoolId: string,
  discussionId: string,
) => {
  return myAxios.delete(
    `${myBaseUrlDomain}/school-discussion/v2/upvotes/${discussionId}/?&school_id=${schoolId}`,
  )
}

export const BookmarkDiscussion = (schoolId: string, discussionId: string) => {
  const body = { discussion_id: discussionId }
  return myAxios.put(
    `${myBaseUrlDomain}/school-discussion/v2/bookmarks/?&school_id=${schoolId}`,
    body,
  )
}

export const RemoveDiscussionBookmark = (
  schoolId: string,
  discussionId: string,
) => {
  return myAxios.delete(
    `${myBaseUrlDomain}/school-discussion/v2/bookmarks/${discussionId}/?&school_id=${schoolId}`,
  )
}

export const GetBookmarkedDiscussions = (schoolId: string) => {
  return myAxios.get(
    `${myBaseUrlDomain}/school-discussion/v2/bookmarks/?&school_id=${schoolId}`,
  )
}

export const AddAvailableCourseSchedule = (
  school_id: string,
  course_id: string,
  start_time: string,
  end_time: string,
  live_class_title: string,
  live_class_platform: ILiveClassPlatform,
  repeatclass_schedule: IRepeatClassSchedule,
  selected_students: string[],
  liveclass_link: string,
  liveclass_note: string,
) => {
  const body = {
    school_id: school_id,
    course_id: course_id,
    start_time: start_time,
    end_time: end_time,
    live_class_platform: live_class_platform,
    live_class_link: liveclass_link,
    repeat_class_schedule: repeatclass_schedule,
    selected_students: selected_students,
    live_class_note: liveclass_note,
    live_class_title: live_class_title,
  }

  return myAxios.post(
    `${myBaseScheduleUrl}/available-course-schedule?&school_id=${school_id}`,
    body,
  )
}

export const UpdateAvailableCourseSchedule = (
  available_course_schedule_id: string,
  school_id: string,
  course_id: string,
  start_time: string,
  end_time: string,
  live_class_title: string,
  live_class_platform: ILiveClassPlatform,
  repeatclass_schedule: IRepeatClassSchedule,
  selected_students: string[],
  liveclass_link: string,
  liveclass_note: string,
) => {
  const body = {
    available_course_schedule_id: available_course_schedule_id,
    school_id: school_id,
    course_id: course_id,
    start_time: start_time,
    end_time: end_time,
    live_class_platform: live_class_platform,
    live_class_link: liveclass_link,
    repeat_class_schedule: repeatclass_schedule,
    selected_students: selected_students,
    live_class_note: liveclass_note,
    live_class_title: live_class_title,
  }

  return myAxios.put(
    `${myBaseScheduleUrl}/available-course-schedule?&school_id=${school_id}`,
    body,
  )
}

export const NotifyStudentsOfUnscheduledLiveClass = (course_id: string) => {
  const body = { courseId: course_id }
  return myAxios.post(`${myBaseScheduleUrl}/unscheduled-live-class`, body)
}

export const GetAvailableCourseScheduleByCourse = (
  course_id: string,
  school_id: string,
) => {
  return myAxios.get(
    `${myBaseScheduleUrl}/available-course-schedule-by-course/${course_id}?&school_id=${school_id}`,
  )
}

export const GetAvailableCourseScheduleByCourseContent = (
  course_content_id: string,
  school_id: string,
) => {
  return myAxios.get(
    `${myBaseScheduleUrl}/available-course-schedule-by-course-content/${course_content_id}?&school_id=${school_id}`,
  )
}

export const GetAvailableCourseScheduleByCreator = (
  creator_id: string,
  school_id: string,
) => {
  return myAxios.get(
    `${myBaseScheduleUrl}/available-course-schedule-by-creator/${creator_id}?&school_id=${school_id}`,
  )
}

export const GetAvailableCourseScheduleForUser = (school_id: string) => {
  return myAxios.get(
    `${myBaseScheduleUrl}/available-course-schedule/?&school_id=${school_id}`,
  )
}

export const GetAvailableCourseScheduleBySchool = (school_id: string) => {
  return myAxios.get(
    `${myBaseScheduleUrl}/available-course-schedule-by-school/${school_id}?&school_id=${school_id}`,
  )
}

export const DeleteAvailableCourseSchedule = (
  available_course_schedule_id: string,
  school_id: string,
) => {
  return myAxios.delete(
    `${myBaseScheduleUrl}/available-course-schedule/${available_course_schedule_id}?&school_id=${school_id}`,
  )
}

// deprecated
export const sendMessageToSingleStudent = (
  message: string,
  course_id: string | undefined,
  student_id: string,
  school_id: string,
) => {
  const body = {
    message: message,
  }
  return myAxios.post(
    `${myBaseUrlDomain}/students/v2/send-message-to-student/${student_id}/${
      course_id || ''
    }?&school_id=${school_id}`,
    body,
  )
}

export const sendEndOfCourseMessageToStudent = (
  school_id: string,
  course_id: string | undefined,
  student_id: string | undefined,
) => {
  const body = {
    course_id: course_id,
    student_id: student_id,
  }
  return myAxios.post(
    `${myBaseUrlDomain}/courses/v2/students-end-of-course-message?school_id=${school_id}`,
    body,
  )
}

export const sendEndOfCourseMessageToAdmin = (
  student_id: string | undefined,
  course_id: string | undefined,
) => {
  const body = {
    student_id: student_id,
    course_id: course_id,
  }
  return myAxios.post(
    `${myBaseUrlDomain}/courses/v2/admin-end-of-course-message`,
    body,
  )
}

export const UpdateStudentBankDetails = (opts: {
  student_id: string
  bank_details: string
}) => {
  const body = opts
  return myAxios.put(
    `${myBaseUrlDomain}/students/v2/${opts.student_id}/bank-details`,
    body,
  )
}

export const getCoursesStudentHasAccessTo = (schoolId: string) => {
  return myAxios.get(
    `${myBaseUrlDomain}/courses/v2/student-has-access?&${
      schoolId && 'school_id=' + schoolId
    }`,
  )
}

export const searchForSchoolOnFindSchool = (
  searchQuery: string,
  filterTag: string = '',
) => {
  return myAxios.get(
    `${myBaseUrlDomain}/schools/v2/search-for-school-on-find-school?&searchQuery=${searchQuery}&filterTag=${filterTag}`,
  )
}

export const getFindSchoolSettings = (opts: { addCourses: boolean }) => {
  return myAxios.get(
    `${myBaseUrlDomain}/pledre-settings/v1/setting/find-school?&addCourses=${opts.addCourses}&searchQuery=`,
  )
}

export const RequestForSchoolOnFindSchool = (
  user_email: string,
  request: string,
) => {
  const body = {
    user_email: user_email,
    request: request,
  }
  return myAxios.post(
    `${myBaseUrlDomain}/schools/v2/request-for-school-on-find-school`,
    body,
  )
}

export const GetSchoolNotificationSettings = (schoolId: string) => {
  return myAxios.get(
    `${myBaseUrlDomain}/schools/v2/notification-settings/?&school_id=${schoolId}`,
  )
}

export interface INotificationSettingsOpts {
  notify_students_on_approval_to_course?: boolean
  notify_students_on_unapproval_to_course?: boolean
  notify_students_on_deletion_from_course?: boolean
}

export const UpdateNotificationSettings = (
  schoolId: string,
  opts: INotificationSettingsOpts,
) => {
  const body = {
    notify_students_on_approval_to_course:
      opts.notify_students_on_approval_to_course,
    notify_students_on_unapproval_to_course:
      opts.notify_students_on_unapproval_to_course,
    notify_students_on_deletion_from_course:
      opts.notify_students_on_deletion_from_course,
  }
  return myAxios.put(
    `${myBaseUrlDomain}/schools/v2/notification-settings/?&school_id=${schoolId}`,
    body,
  )
}

// for school-users request
export const GetApprovedStudentListRequest = (
  schoolId: string,
  searchQuery: string = '',
  scope: 'course' | 'school' = 'school',
  courseId?: string,
) => {
  return myAxios.get(
    `${myBaseUrlDomain}/schools/v2/students/?school_id=${schoolId}&searchQuery=${searchQuery}&scope=${scope}${
      scope === 'course' ? `&course_id=${courseId}` : ''
    }`,
  )
}

export const GetUserDetailsFromIdRequest = (
  schoolId: string,
  userId: String,
) => {
  return myAxios.get(
    `${myBaseUrlDomain}/schools/v2/school/${schoolId}/user_details/${userId}?school_id=${schoolId}`,
  )
}
